import { Form } from "antd";
import styled from "styled-components";

export const StyledForm = styled(Form)`
  &.renderbus-ui--form {
    .ant-form-item {
      line-height: 1.5715;
    }
    .ant-form-item-label > label {
      color: #fff;
      &::after {
        margin: 0 24px 0 2px;
      }
      &.ant-form-item-no-colon::after {
        margin: 0 24px 0 0;
      }
    }
    .ant-form-item-label > label.ant-form-item-no-colon::after {
      margin-right: 16px;
    }
  }
  &.verification-form {
    .ant-form-item {
      margin-bottom: 18px;
    }
    .ant-form-item-label > label {
      color: #d4d4d4;
      height: 22px;
    }
    .ant-form-item .ant-form-item-label {
      padding-bottom: 6px;
    }
    .ant-input-affix-wrapper {
      border: 0;
      height: 40px;
      line-height: 1;
    }
  }
  &.project-manage-form {
    margin: 20px 16px 0;
  }
`;
